/**
 * Phần tử công thức
 */
export default {
  /**
   * Phần tử
   */
  Factor: 0,
  /**
   * Toán tử
   */
  Operator: 1,
};
